import { Colors, Heading, Text } from '@amelio/ui-library';

import type { ReactNode } from 'react';

const PAGE_TITLE_TYPE = 'text-[36px] leading-[40px] font-semibold';
const PAGE_SUBTITLE_TYPE = 'mt-[8px] text-[18px] leading-[28px]';

interface FormNavigatorPageHeaderProps {
    pageTitle: string;
    pageSubtitle?: string;
    notice?: ReactNode;
    banner?: ReactNode;
}

export const FormNavigatorPageHeader = ({
    pageTitle,
    pageSubtitle,
    notice,
    banner,
}: FormNavigatorPageHeaderProps) => (
    <header
        className={'cycle-rail-gutter pb-[32px]'}
        data-testid={'form-navigator-page-header'}
    >
        <div className={'flex flex-wrap items-center justify-between gap-x-6 gap-y-3'}>
            <Heading
                level={1}
                color={Colors.SLATE}
                className={PAGE_TITLE_TYPE}
            >
                {pageTitle}
            </Heading>

            {notice}
        </div>

        {pageSubtitle && (
            <Text
                color={Colors.STEP_RAIL_MUTED}
                className={PAGE_SUBTITLE_TYPE}
            >
                {pageSubtitle}
            </Text>
        )}

        {banner}
    </header>
);
